<template>
  <aside :class="['goal-change-panel', { '-full-screen': fullScreen }]">
    <div class="_header">
      <m-tooltip placement="bottom">
        <m-btn
          hide-border
          small
          fab
          :icon="fullScreen ? 'close' : 'double-right'"
          :icon-color="$colors.grey.base"
          @click="$emit('close')"
        />
        <template #title>
          {{ $t('general.close') }}
        </template>
      </m-tooltip>
    </div>
    <div class="_tabs">
      <div class="_tab">
        {{ $t('goalChanges.title') }}
      </div>
    </div>
    <div class="_body">
      <goal-change-list :goal="goal" />
    </div>
  </aside>
</template>

<script setup>
import GoalChangeList from '@/components/goal/GoalChangeList.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

defineProps({ goal: { type: Object, required: true } });
defineEmits(['close']);

const store = useStore();
const fullScreen = computed(() => store.state.breakpoint.smAndDown);
</script>

<style scoped lang="scss" type="text/scss">
  .goal-change-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-left: 1px solid $border-color-dark;

    ._header {
      display: flex;
      flex: 0 0 4.5rem;
      align-items: center;
      padding: 0 1.2rem;
      opacity: 0;
      transition: opacity .15s ease-in-out;
    }

    &:hover ._header,
    ._header:focus-within {
      opacity: 1;
    }

    &.-full-screen {
      border-left: none;

      ._header {
        justify-content: flex-end;
        opacity: 1;
      }
    }

    ._tabs {
      display: flex;
      padding: 0 1.6rem;
      border-bottom: 1px solid $border-color;
    }

    ._tab {
      padding: .6rem 0;
      margin-bottom: -1px;
      font-weight: $font-weight-medium;
      border-bottom: 2px solid $font-color-primary;
    }

    ._body {
      flex: 1 1 auto;
      padding: 0 1.6rem 2rem;
      overflow-y: auto;
    }
  }
</style>
